module.exports = __webpack_public_path__ + "img/instruction_1.b98b1b83.svg";